
<section *ngIf="_accessToken && _planId" class="login text-center">
    <div>
        <div class="container-inner mb-6">
            <div class="px-3 py-3 w-100">
                <div class="col d-flex justify-content-between align-items-center login-head">
                    <img src="assets/images/logo.svg" alt="">
                    <app-support-help></app-support-help>
                </div>
            </div>
        </div>

        <div class="login-content-wrapper mx-auto">

            <div class="heading-with-back-arrow">
                <div class="back-annual-plan mt-0 mb-4">
                </div>

                <div class="d-flex align-items-center mb-0 w-100">
                    <div class="w-100">
                        <p class="heading text-center w-100 mb-4">Renew Subscription</p>
                    </div>
                </div>
            </div>

            <div class="login-content login-box box_shodow renewal-summary" *ngIf="selectedPlanInfo">
                <dl class="renewal-summary__list">
                    <ng-container *ngIf="currentPlanInfo">
                        <dt>Current subscription</dt>
                        <dd>{{ currentPlanInfo.name }}</dd>
                    </ng-container>
                    <dt>Renewal plan</dt>
                    <dd>{{ selectedPlanInfo.name }}</dd>
                    <dt>Due today</dt>
                    <dd>{{ selectedPlan.amount | currency:(selectedPlan.currency | uppercase):'symbol':'1.2-2' }}</dd>
                    <ng-container *ngIf="nextChargeDate as chargeDate">
                        <dt>Next charge date</dt>
                        <dd>{{ chargeDate | date: dateFormat : 'UTC' }}</dd>
                    </ng-container>
                </dl>
            </div>

            <form novalidate (ngSubmit)="onPay()" [formGroup]="stripeTest">
                <input type="hidden" formControlName="name">
                <div class="login-content login-box box_shodow stripe-card-box">
                    <fieldset class="payment-method" *ngIf="_savedCard" [disabled]="_processingPayment || _paymentSuccessfull">
                        <legend class="payment-method__legend">Payment Method</legend>
                        <label class="payment-method__option">
                            <input type="radio" name="paymentMethod" [checked]="_payWithSavedCard"
                                (change)="onPaymentMethodChange(true)">
                            Saved card: {{ _savedCard.brand }} ending {{ _savedCard.last4 }}
                            (exp {{ _savedCard.expMonth }}/{{ _savedCard.expYear }})
                        </label>
                        <label class="payment-method__option">
                            <input type="radio" name="paymentMethod" [checked]="!_payWithSavedCard"
                                (change)="onPaymentMethodChange(false)">
                            Use a new card
                        </label>
                    </fieldset>

                    <ngx-stripe-card [hidden]="_payWithSavedCard" [options]="cardOptions" class="stripe-card"
                        [elementsOptions]="elementsOptions" (change)="onCardChange($event)">
                    </ngx-stripe-card>

                    <div class="renewal-status" role="status" aria-live="polite">{{ _statusMessage }}</div>
                    <div class="renewal-error" role="alert" *ngIf="_errorMessage">{{ _errorMessage }}</div>

                    <div class="rounded text-center mb-4">
                        <button
                            class="btn large_btn rounded_btn green_btn w-100"
                            mat-flat-button
                            color="primary"
                            type="submit"
                            [disabled]="!canPay || _processingPayment || _paymentSuccessfull"
                            [attr.aria-busy]="_processingPayment">
                            <ng-container *ngIf="!_processingPayment && !_paymentSuccessfull">Renew and Pay</ng-container>
                            <ng-container *ngIf="_processingPayment">Processing payment</ng-container>
                            <ng-container *ngIf="_paymentSuccessfull">Subscription renewed</ng-container>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>
